'use client';

import { useEffect } from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Erro na aplicacao:', error);
  }, [error]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 px-4 text-center">
      <AlertTriangle className="h-24 w-24 text-destructive" />
      <div className="space-y-2">
        <h1 className="text-4xl font-bold">500</h1>
        <h2 className="text-xl font-medium text-muted-foreground">
          Erro interno
        </h2>
        <p className="text-sm text-muted-foreground">
          Ocorreu um erro inesperado. Tente novamente mais tarde.
        </p>
      </div>
      <Button onClick={reset}>Tentar novamente</Button>
    </div>
  );
}
